import { useEffect, useState } from "react";
import { useAssignedClientSelection, useRequest } from "../../../hooks";
import {
  DocRow,
  DocumentsPortalLayout,
} from "../../../components/documents/DocumentsPortalLayout";

const isSuccessful = (response: any) => response?.success || response?.succes;

export const AdditionalDocumentsClient = () => {
  const { handleRequest } = useRequest();
  const {
    selectedClientId,
    clientOptions,
    showClientFilter,
    setSelectedClientId,
  } = useAssignedClientSelection();
  const [rows, setRows] = useState<DocRow[]>([]);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!selectedClientId) return;
    setRowsLoading(true);
    handleRequest({
      endpoint: `additional-document-list/client/${selectedClientId}`,
      options: { method: "GET" },
    })
      .then((response) => {
        const docs: DocRow[] = (isSuccessful(response) ? response.data : []).map(
          (item: any) => ({
            rowId: `ad-${item.id}`,
            customName: item.customName,
            date: item.date ?? "",
            wellName: "",
            source: "uploaded" as const,
            path: item.path,
            owner: "—",
            mimeType: item.mimeType,
            originalFileName: item.originalFileName,
          }),
        );
        setRows(docs);
      })
      .catch(() => setIsError(true))
      .finally(() => setRowsLoading(false));
  }, [selectedClientId]);

  const downloadFile = async (row: DocRow) => {
    if (!row.path) return;
    const response = await handleRequest({
      endpoint: "additional-document-download",
      options: {
        method: "POST",
        body: JSON.stringify({ key: row.path }),
        headers: { responseType: "Buffer" } as any,
      },
    });
    if (!response.success) {
      setIsError(true);
      return;
    }
    const mimeType = response.mimeType || row.mimeType || "application/octet-stream";
    const url = window.URL.createObjectURL(
      new Blob([new Uint8Array(response.data.data).buffer], { type: mimeType }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", row.originalFileName || row.customName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <DocumentsPortalLayout
      title="Additional Documents"
      subtitle="Browse, filter and download additional documents"
      wells={[]}
      wellsLoading={false}
      rows={rows}
      rowsLoading={rowsLoading}
      selectedWellId={null}
      onWellSelect={() => {}}
      onDownload={downloadFile}
      showSource={false}
      hideWellsPanel
      showClientFilter={showClientFilter}
      selectedClientId={selectedClientId}
      clientOptions={clientOptions}
      onClientChange={(client) => setSelectedClientId(client?.id ?? null)}
      noWellMessage="Select a client to see additional documents"
      isError={isError}
    />
  );
};
